import React from "react";
import PaymentPlanTableHeader from "./UI/PaymentPlanTableHeader/PaymentPlanTableHeader";

export const PaymentPlanTableHeaderData = (
  isDarkMode = false,
  handleFilterConfirm
) => [
  {
    id: 1,
    formFieldId: 1,
    minWidth: 240,
    headerName: "Plan name",
    field: "PlanName",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "PlanName",
    isDefaultFilterColumn: true,
    fieldKey: "PlanName",
    formFieldTitle: "Plan name",
    disableColumnMenu: true,
    searchKey: "PlanName",
    renderHeader: (params) => (
      <PaymentPlanTableHeader
        params={params}
        handleFilterConfirm={handleFilterConfirm}
        title="Plan Name"
        hideSelect={true}
      />
    ),
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
            wordBreak: "break-word",
            maxWidth: 200,
            whiteSpace: "normal",
            display: "block",
          }}
        >
          {item?.row?.paymentPlanName || "N/A"}
        </label>
      );
    },
  },
  {
    id: 2,
    formFieldId: 2,
    minWidth: 220,
    headerName: "Down payment",
    field: "downPayment",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "downPayment",
    isDefaultFilterColumn: true,
    fieldKey: "downPayment",
    formFieldTitle: "Down payment",
    disableColumnMenu: true,
    searchKey: "downPayment",
    renderHeader: (params) => (
      <PaymentPlanTableHeader
        params={params}
        title="Down payment"
        inputType="number"
        handleFilterConfirm={handleFilterConfirm}
      />
    ),
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#475467" : "#94969C",
          }}
        >
          {item?.row?.downPayment || 0}
        </label>
      );
    },
  },
  {
    id: 3,
    formFieldId: 3,
    minWidth: 300,
    headerName: "Installment",
    field: "installment",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "installment",
    isDefaultFilterColumn: true,
    fieldKey: "installment",
    formFieldTitle: "Installment",
    disableColumnMenu: true,
    searchKey: "installment",
    renderHeader: (params) => (
      <PaymentPlanTableHeader
        params={params}
        title="Installment"
        isHiddenFilter={true}
      />
    ),
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#475467" : "#94969C",
            wordBreak: "break-word",
            maxWidth: 200,
            whiteSpace: "normal",
            display: "block",
          }}
        >
          {item?.row?.monthlyInstallment || "N/A"}
        </label>
      );
    },
  },
  {
    id: 4,
    formFieldId: 4,
    minWidth: 300,
    headerName: "Handover Payment",
    field: "handoverPayment",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "handoverPayment",
    isDefaultFilterColumn: true,
    fieldKey: "handoverPayment",
    formFieldTitle: "Handover Payment",
    disableColumnMenu: true,
    searchKey: "handoverPayment",
    renderHeader: (params) => (
      <PaymentPlanTableHeader
        params={params}
        title="Handover Payment"
        inputType="number"
        handleFilterConfirm={handleFilterConfirm}
      />
    ),
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.handoverPayment || 0}
        </label>
      );
    },
  },
  {
    id: 5,
    formFieldId: 5,
    minWidth: 300,
    headerName: "Post-Handover",
    field: "postHandover",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "postHandover",
    isDefaultFilterColumn: true,
    fieldKey: "postHandover",
    formFieldTitle: "Post-Handover",
    disableColumnMenu: true,
    searchKey: "postHandover",
    renderHeader: (params) => (
      <PaymentPlanTableHeader
        params={params}
        title="Post-Handover"
        isHiddenFilter={true}
      />
    ),
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#475467" : "#94969C",
            wordBreak: "break-word",
            maxWidth: 200,
            whiteSpace: "normal",
            display: "block",
          }}
        >
          {item?.row?.postHandover || "N/A"}
        </label>
      );
    },
  },
  {
    id: 6,
    formFieldId: 6,
    minWidth: 170,
    headerName: "Status",
    field: "status",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "status",
    isDefaultFilterColumn: true,
    fieldKey: "status",
    formFieldTitle: "Status",
    disableColumnMenu: true,
    searchKey: "status",
    renderHeader: (params) => (
      <PaymentPlanTableHeader
        params={params}
        title="Status"
        hideInput={true}
        handleFilterConfirm={handleFilterConfirm}
      />
    ),
    renderCell: (item) => {
      const status = item?.row?.statusName?.toLowerCase();
      let color = "#101828";
      if (status === "active") color = "#17B26A";
      else if (status === "inactive") color = "#F04438";
      return (
        <label
          style={{
            fontWeight: 400,
            color,
          }}
        >
          <ul>
            <li>{item?.row?.statusName || "N/A"}</li>
          </ul>
        </label>
      );
    },
  },
];
